import React from "react";
import cx from "classnames";
import { upperFirst } from "lodash-es";

import styles from "./icon-container.module.scss";
import { classMapper } from "../utils";

const classMap = {
  strokeWidth: {
    thin: styles.iconContainerStrokeWidthThin,
    thick: styles.iconContainerStrokeWidthThick
  }
};

export namespace IconContainer {
  export type Props = React.HTMLProps<HTMLElement> & {
    icon: React.ElementType;
    positioning?: boolean;
    size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    strokeWidth?: keyof typeof classMap.strokeWidth;
    theme?:
      | "primary"
      | "secondary"
      | "tertiary"
      | "warning"
      | "danger"
      | "light"
      | "dark"
      | "black"
      | "white";
  };
}

export const IconContainer = ({
  className,
  icon: Icon,
  positioning = true,
  size,
  strokeWidth = "thin",
  theme,
  ...props
}: IconContainer.Props): JSX.Element => {
  const classList = cx(
    className,
    styles.iconContainer,
    positioning && styles.iconContainerPositioned,
    // Allow interpolation given large set
    size && styles[`iconContainerSize${size}` as keyof typeof styles],
    ...classMapper(classMap, {
      strokeWidth
    }),
    theme && styles[`iconContainer${upperFirst(theme)}` as keyof typeof styles]
  );

  return (
    <i {...props} className={classList}>
      <Icon />
    </i>
  );
};

export default IconContainer;
